import angular from 'angular';
import DiscountsModal from './discounts.modal.component';
export default angular.module('invision.customercare.discountsModal', []).component('discountsModal', DiscountsModal).name;